import { TeamMemberRole } from '../gen/graphql';

export const TeamMemberRoleLabels: { [key: string]: string } = {
  [TeamMemberRole.Admin]: '管理者',
  [TeamMemberRole.General]: 'メンバー',
} as const;
